import { CellProps } from 'react-table';
import { TableCustomCell } from '../../../../component/table/components/TableCustomCell';
import { formatMoney } from '../../../../utils/FormatUtils';

const UnitPriceCell = ({ row, tableOptions }: CellProps<any>) => {
	const { getObjectPriceFieldConfig } = tableOptions;
	const rowData = row.original;
	const data = rowData?.attributes?.[getObjectPriceFieldConfig(rowData?.visitObjectType?.code)];

	return <TableCustomCell className="text-end " data={formatMoney(data) || 0} />;
};

export default UnitPriceCell;
